import { render, staticRenderFns } from "./InvoiceOverviewDashboard.vue?vue&type=template&id=50c323f0&scoped=true"
import script from "./InvoiceOverviewDashboard.vue?vue&type=script&lang=js"
export * from "./InvoiceOverviewDashboard.vue?vue&type=script&lang=js"
import style0 from "./InvoiceOverviewDashboard.vue?vue&type=style&index=0&id=50c323f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c323f0",
  null
  
)

export default component.exports